import React from "react";
import usePermissions from "../hooks/usePermissions";

/**
 * Permission Component
 * Shows/hides content based on permissions
 */
const Permission = ({
  permission,
  action,
  roleManagement,
  children,
  ...props
}) => {
  const { hasPermission, canPerformAction, canManageRole, loading, userRole } =
    usePermissions();

  // Show nothing while loading
  if (loading) {
    return null;
  }

  // Show nothing if no user
  if (!userRole) {
    return null;
  }

  let hasAccess = false;

  try {
    if (roleManagement) {
      hasAccess = canManageRole(roleManagement);
    } else if (action) {
      hasAccess = canPerformAction(action);
    } else if (permission) {
      hasAccess = hasPermission(permission);
    } else {
      hasAccess = true; // No permission required
    }
  } catch (error) {
    console.error("Permission: Error checking access:", error);
    hasAccess = false;
  }

  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
};

export default Permission;
